import React from 'react';
import { Text } from 'v3/components';

export default function CardToWarn({
  text = '',
  backgroundColor = '#FFF3CD',
  borderColor = '#FFCA6B',
  textColor = '#856404',
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        backgroundColor: backgroundColor,
        border: `1px solid ${borderColor}`,
        borderRadius: 8,
        padding: '10px 14px',
        marginBottom: 16,
      }}
    >
      <span style={{ fontSize: 18, lineHeight: 1.4 }}>⚠️</span>
      <Text type="regular" style={{ color: textColor, lineHeight: 1.5 }}>
        {text}
      </Text>
    </div>
  );
}
